import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { downloadFile, formatDateToPtbr, translate } from '../../../../../utils/util';
import ContainerService from '../../../../../services/ContainerService';
import { Breadcrumbs, Button, Collapsible, Input, Table } from '../../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../../utils/handleChangeHooks';

const AreaVirtual = (props) => {
    const [currentPage, setCurrentPage] = useState({ pageSize: 5, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [areaVirtual, setAreaVirtual] = useState([]);
    const [filter, setFilter] = useState({});

    useEffect(() => {
        setAreaVirtual(props.areaVirtual?.items || []);
        // eslint-disable-next-line
    }, [props?.areaVirtual?.items]);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (click) => {
        props.getAreasPaged({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const exportCsv = () => {
        props.exportCsv(filter, (data) => {
            downloadFile(data, `areaVirtual${Date.now()}.csv`, "data:text/csv", false);
        })
    }

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: true
            },
            {
                field: 'name',
                header: 'Nome Area',
                align: 'left',
                sortable: true
            },
            {
                field: 'physicalLocation',
                header: 'Local Físico',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                header: 'Criado Por',
                align: 'left',
            }
        ];
        return cols;
    };

    const configActions = () => [
        {
            function: (row) => (
                <i
                    className="material-icons"
                    onClick={() => {
                        props.deleteArea(row.id, () => { onSearch(true); });
                    }}
                    style={{ fontSize: "1.85rem", cursor: "pointer", color: "red" }} > delete
                </i>
            )
        }
    ];

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('container:config:patio.virtual-area') }} />
            <i className={`mdi mdi-36px mdi-sticker-plus above-btn`}
                style={{ cursor: 'pointer' }}
                onClick={() => props.history.push({ pathname: './area/insert' })} />
            {
                areaVirtual.length > 0 && <i className={`mdi mdi-36px mdi-file-excel above-btn`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => exportCsv()} />
            }
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('expedition:picking.filter')}
                        body={
                            <>
                                <div className="row">
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="name"
                                            name='name'
                                            label="Nome Area"
                                            type="text"
                                            defaultValue={filter?.name || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />
                </div>
                <div id="areaVirtual" className="container-fluid">
                    <Table
                        totalPages={props.areaVirtual.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        col={configColumn()}
                        data={areaVirtual}
                        actions={configActions()} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        areaVirtual: state.containerReducer.areaVirtualPaged
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAreasPaged: (filter) => {
            dispatch(ContainerService.getAreasPaged(filter));
        },
        setArea: (area) => {
            dispatch(ContainerService.setAreaVirtual(area));
        },
        deleteArea: (id, callback) => {
            dispatch(ContainerService.deleteArea(id, callback));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportAreaCsv(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AreaVirtual));